export default __webpack_public_path__ + "static/media/motus.16520d7a.svg";